<div class="topdiv" [style.background-color]="backgroundColorScreen">
    <div>
        <mat-toolbar class="agGridtoperDiv card" style="
                background: rgb(228 227 230 / 41%);border-top: 1px solid #a9a9a9a8;
        border-right: 1px solid #a9a9a9a8;
        border-left: 1px solid #a9a9a9a8;">

            <label i18n="@@spmsUserReg" class="textColour">Object Groups</label>
            <span class="example-spacer"></span>
            <div></div>
          

            <!-- <div class="file-field" style="width: 15%;  display: flex;align-items: center; gap: 5px; border: solid red 1px;">
                <a class="btn-floating btn-sm ml-4 m-0">
                    <em class="fas fa-paperclip"></em>
                    <input type="file" id="imageupload" name="imageupload"
                        formControlName="imageupload">
                </a>
                
                
               
            </div> -->
          
            <mat-radio-group aria-label="Select an option"
                style="font-size: 14px; margin-right: 50px; padding-top: 10px;" class="textColour"
                [(ngModel)]="selectedOptionForRadioBtn">
                <!-- <mat-radio-button value="Reporting Group" (change)="onOptionChangeRadioBtn('Reporting Group')"
                    style="margin-bottom: 5px;">Reporting Group</mat-radio-button>
                <mat-radio-button value="Extraction Group" (change)="onOptionChangeRadioBtn('Extraction Group')"
                    style="margin-left: 20px;">Extraction Group</mat-radio-button> -->
            </mat-radio-group>


            <!-- <button id="addrecord" class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="buttonColor" title="Add Record" (click) = "openSaveForm()">Add Record<em style="padding: 0px 0px 0px 10px;" class="fas fa-plus-circle" title="Add Record"></em>

                    </button> -->

                    <!-- ========================================================== -->
                    
                    <button class="popup gridColour btn btn-rounded-button z-depth-1
                            waves-effect waves-light text-capitalize" [style.background-color]="buttonColor" [style.min-width.px]="100"
                        style="font-size: 12px; padding: 4px 10px; height: 32px;" id="102" title="Import Data" (click)="importData()">
                        Import
                        <em class="fas fa-download" style="font-size: 12px; padding: 0 5px;" title="Import Data"></em>
                    </button>
                    <!-- Import Button -->
                    <button class="popup gridColour btn btn-rounded-button z-depth-1
                                                   waves-effect waves-light text-capitalize" [style.background-color]="buttonColor"
                        [style.min-width.px]="100" style="font-size: 12px; padding: 4px 10px; height: 32px;" id="103" title="Export Data"
                        (click)="exportData()">
                        Export
                        <em class="fas fa-upload" style="font-size: 12px; padding: 0 5px;" title="Export Data"></em>
                    </button>
                    
                    <!-- ================================================ -->
            <button id="addrecord"
                class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                [style.background-color]="buttonColor" title="Add Record"
                *ngIf="selectedOptionForRadioBtn === 'Reporting Group'" (click)="openSaveForm()" >Add Record<em
                    style="padding: 0px 0px 0px 10px;" class="fas fa-plus-circle" title="Add Record"></em>
            </button>
           <div >
            <button style="width: 150px;" class=" gridColour btn btn-rounded-button  text-capitalize" [style.background-color]="buttonColor"  title="Upload Template" (click)="uploadGroupTemplate()" id="108">Upload Template
                <em style="padding: 0px 0px 0px 0px;" class="fas fa-upload example-icon" title="Upload Template"></em>
            </button>
            <button id="addrecord"
            class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
            [style.background-color]="buttonColor" title="Add Record"
            *ngIf="selectedOptionForRadioBtn === 'Extraction Group'" (click)="openSaveForm2()" id="114">Add Record<em
                style="padding: 0px 0px 0px 10px;" class="fas fa-plus-circle" title="Add Record"></em>
        </button>
        <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
            [style.background-color]="buttonColor" title="Download" (click)="downlod()">Download
            <em style="padding: 0px 0px 0px 10px;" class="fas fa-download example-icon" title="Download"></em>
        </button>
           </div>
           

            <div class="insertPageNoDiv">
                <mat-form-field appearance="outline">
                    <mat-label i18n="@@spmsUserRegpageno">Page No</mat-label>
                    <input matInput type="text" (input)="onSearchChange($event.target.value)">
                </mat-form-field>
            </div>

            <div class="selectRecordsDiv" style="width:9.5%">
                <mat-form-field appearance="outline" style="width:100%">
                    <mat-label i18n="@@spmsUserRegrecords" style="color:black">Records</mat-label>
                    <mat-select ngDefaultControl [(ngModel)]="pagesize" (ngModelChange)="onPageSizeChanged(value)">
                        <mat-option value="10" selected>10</mat-option>
                        <mat-option value="200">200</mat-option>
                        <mat-option value="300">300</mat-option>
                        <mat-option value="400">400</mat-option>
                    </mat-select>

                </mat-form-field>
            </div>
            <div class="card pagination paginationFirstButton paginationFirstlastButton">
                <em class="fas fa-angle-double-left waves-effect waves-light" (click)="onBtFirst()"></em>
            </div>
            <div class="card pagination paginationButtons btn-rounded">
                <ul>
                    <li class="paginationliicon"><em class="fas fa-angle-left waves-effect waves-light"
                            (click)="onBtPrevious()"></em></li>
                    <li>{{currentpage}}/{{totalpages}}</li>
                    <li class="paginationliicon" style="padding:0;"><em
                            class="fas fa-angle-right waves-effect waves-light" (click)="onBtNext()"></em></li>
                </ul>
            </div>
            <div class="card pagination paginationLastButton paginationFirstlastButton">
                <em class="fas fa-angle-double-right waves-effect waves-light" (click)="onBtLast()"></em>
            </div>
        </mat-toolbar>
    </div>
    <ag-grid-angular class="ag-theme-balham table-width tablestyles square scroolbar-dusty-grass square thin"
        [columnDefs]="columnDefs" [animateRows]="true" [pagination]="true" [defaultColDef]="defaultColDef"
        [suppressPaginationPanel]="true" [rowHeight]="35" [headerHeight]="35" [enableBrowserTooltips]="true"
        [floatingFiltersHeight]="45" [paginationPageSize]="paginationPageSize"
        [paginationNumberFormatter]="paginationNumberFormatter" [enableRangeSelection]="true" [debug]="true"
        [rowClassRules]="rowClassRules" (paginationChanged)="onPaginationChanged()"
        [components]="components" (gridReady)="onGridReady($event)" [hidden]="!true">
    </ag-grid-angular>
</div>